import { atom } from 'recoil';

export type TaskTimeSuggestionStatus = 'idle' | 'pending' | 'suggested' | 'failed';

export interface TaskTimeSuggestionState {
  status: TaskTimeSuggestionStatus;
  startTime?: string;
  endTime?: string;
  reasoning?: string;
  suggestedAt?: string;
}

export type TaskTimeSuggestionMap = Record<string, TaskTimeSuggestionState>;

export const taskTimeSuggestionMapAtom = atom<TaskTimeSuggestionMap>({
  key: 'taskTimeSuggestionMap',
  default: {},
});
